module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p +=
((__t = ( i18next.t('etls.activation_confirmation', { name }) )) == null ? '' : __t) +
'\n';

}
return __p
}